import { disallowInsecureCharacters, required } from '@seek/validators-js';
import { TextField } from 'braid-design-system';
import React from 'react';

import { mapBraidFieldProps } from 'src/utils/mapBraidFieldProps';

import { useField } from '../formState';

const LastNameField = () => {
  const lastName = useField({
    id: 'lastName',
    validators: [required, disallowInsecureCharacters],
  });

  return (
    <TextField
      id="last-name-field"
      label="Last name"
      {...mapBraidFieldProps(lastName)}
    />
  );
};

export default LastNameField;
